import React, { memo, useCallback } from 'react';
import { formatCurrency } from '../models/groceryModels';
import './GroceryComponents.css';

const MAX_QUANTITY = 99;

const GroceryItemCard = ({ item, quantity, onQuantityChange }) => {
  const qty = Number(quantity) || 0;
  const isSelected = qty > 0;

  const handleDecrement = useCallback(() => {
    onQuantityChange(item.itemId, Math.max(0, qty - 1));
  }, [item.itemId, qty, onQuantityChange]);

  const handleIncrement = useCallback(() => {
    onQuantityChange(item.itemId, Math.min(MAX_QUANTITY, qty + 1));
  }, [item.itemId, qty, onQuantityChange]);

  const handleInput = useCallback(
    (event) => {
      const parsed = parseInt(event.target.value, 10);
      const next = Number.isNaN(parsed) ? 0 : Math.min(MAX_QUANTITY, Math.max(0, parsed));
      onQuantityChange(item.itemId, next);
    },
    [item.itemId, onQuantityChange]
  );

  return (
    <div className={`grocery-item-card${isSelected ? ' is-selected' : ''}`}>
      <div className="grocery-item-visual">
        {item.itemImage_URL ? (
          <img src={item.itemImage_URL} alt={item.itemName} className="grocery-item-image" />
        ) : (
          <span className="grocery-item-emoji" role="img" aria-label={item.itemName}>
            {item.icon || '\uD83D\uDED2'}
          </span>
        )}
      </div>

      <div className="grocery-item-name">{item.itemName}</div>
      <div className="grocery-item-price">{formatCurrency(item.estimatedPrice)} estimated value</div>

      <div className="grocery-item-footer">
        <div className="grocery-qty">
          <button
            type="button"
            className="grocery-qty-btn"
            onClick={handleDecrement}
            disabled={qty === 0}
            aria-label={`Decrease quantity of ${item.itemName}`}
          >
            &minus;
          </button>
          <input
            type="number"
            className="grocery-qty-value"
            value={qty}
            onChange={handleInput}
            min="0"
            max={MAX_QUANTITY}
            aria-label={`Quantity of ${item.itemName}`}
          />
          <button
            type="button"
            className="grocery-qty-btn"
            onClick={handleIncrement}
            disabled={qty >= MAX_QUANTITY}
            aria-label={`Increase quantity of ${item.itemName}`}
          >
            +
          </button>
        </div>

        {isSelected && (
          <span className="grocery-item-subtotal">{formatCurrency(qty * item.estimatedPrice)}</span>
        )}
      </div>
    </div>
  );
};

export default memo(GroceryItemCard);
